
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"84","height":"77","viewBox":"0 0 84 77"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h84v77H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 961","d":"M30.353 73.03a4.858 4.858 0 01-4.853-4.852c0-17.442 3.772-24.5 6.8-30.166 1.874-3.5 3.493-6.532 3.493-11.012 0-4.456-1.434-11.7-2.93-14.917a1.914 1.914 0 011.9-1.7h1.318l-1.249-5h-1.54c-.313 0-.441-.128-.441-.441s.128-.441.441-.441H50.94c.313 0 .441.128.441.441s-.128.441-.441.441H49.4l-1.249 5h1.318a1.915 1.915 0 011.9 1.7c-1.5 3.218-2.93 10.461-2.93 14.917 0 4.48 1.619 7.507 3.493 11.012 3.03 5.668 6.8 12.724 6.8 30.166a4.858 4.858 0 01-4.853 4.852zm1.03-6.323c0-9.108 1.646-17.018 4.891-23.511.141-.343.3-.46.55-.46h9.706","fill":"none","stroke":"#55534f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}})])])
          )
        }
      }
    